import React, { memo } from 'react';
import PropTypes from 'prop-types';

const CompaniesTableMobile = ({ companies }) => {
  return (
    <div className="cases-table-mobile">
      {companies.map((company) => {
        return (
          <div key={company.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{company.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {company.name}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

CompaniesTableMobile.propTypes = {
  companies: PropTypes.array,
};

export default memo(CompaniesTableMobile);
